import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—January 2006" />
	<Old2005BlogPage>
		<h2>January 2006</h2>






		<h3 className="blogdate">
		Saturday, January 14, 2006
		</h3>






		<h4 className="blogitemtitle">
		Dinner in Phuket Town
		</h4>





			<div className="blogitembody">
			Most nights I just walk out the door of Phuket Backpacker, down Ranong Road, one block to the night market, where hawkers are cooking and selling, and fruit and produce is for sale. I walk past dogs that will probably catch rabies soon - dodging entire families stacked and motoring on small motorcycles - to the maket lane. I usually skip the sweet coconut rice, the mystery-meatballs and squids on sticks, the cockroaches in a bowl, until I reach the Thai-wrap couple. I greet them with "sawatdee krup" and motion for three wraps. He makes them with the speed and precision of a machine, and I watch with fascination each time. I hand her 20 Baht, we exchange smiles and I say "kop koon krup," while she says "kop koon kaa," before I walk away with my main course.<br /><br />Next I walk past the raw fish, chickens, pork, through the fruit and veg, past the deep-frying sesame things, past the buffet stuff, to the sausage couple. The mystery-sausage-on-a-stick has noodles, rice, and pork in it - I can tell someone innovative made these - they're fabulous! 10 Baht for these - one is enough for me. On the way back through the lanes I get a young, green coconut lopped open and a straw installed for slurping... 10 Baht. I love this place!<br /><br />Don't worry, I eat at shops (off the street) for many meals. But the market street is where it's at - and this is what I like about Phuket Town - where the locals buy, sell, and snack. There are very few tourists here in town - they are all Patong Beach, or Kata Beach, or some other beach on this island.<br /><br />Patong Beach is row-upon-row of umbrellas, for more than a kilometer, offering shade in the sand for european breasts and "speedo" sporters. There are many resorts in this beach area, so the westerners can have beach, western food and western comfort - paradise. You have to wonder what stage of sewage evolution has been achieved in these resorts' output into the ocean, at this beach, or any of the tourist beaches. Locals can no longer live at the major beaches due to the highly inflated prices that mainly westerners can afford. But I have digressed from dinner in Phuket Town, so I will sign off now.<br /><br />Links: <a href="http://www.phuketbackpacker.com/">http://www.phuketbackpacker.com/</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:05 PM &nbsp;
			</div>






		<h3 className="blogdate">
		Wednesday, January 04, 2006
		</h3>






		<h4 className="blogitemtitle">
		SE Asian Fruit That I Have Become Friends With
		</h4>





			<div className="blogitembody">
			Durian stinks, and looks like the head of a war mace.  But you gotta try it, and the Malays believe it brings excellent health and vitality (and sexual energy).  The flesh looks like soggy pizza dough, and is rich and creamy, yet sweet.<br /><br />Jackfruit looks similar to durian, but with less (or smaller, or no) spikes.  The flesh is orange and more firm, and more sweet.  I preferred this fruit over durian.  In fact, I preferred all fruit over durian.<br /><br />Rambutans look ridiculously evil, but when you break one open and eat the sweet, almost translucent flesh, you'll smile!  I ate a whole bag of them!  You can't miss them, with their red and green hairy/spikey orbs, on the end of stick-branches.<br /><br />Mangosteens are my favorite:  deep-purple, smooth and matted orbs that, once broken open, seem to have a soft bulb of garlic in them!  But that bulb of garlic is so delicious!<br /><br />Kalamansi - when you order fresh lime juice from a hawker, you are really getting kalamansi juice.  It's like a lime, but small and super tasty-sweet, hardly bitter at all.  I also enjoyed drinking sugar cane juice, which is immensely refreshing, and so is slurping coconut juice through a straw that is stuck into a huge green orb that is a coconut!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:47 PM &nbsp;
			</div>











		<h4 className="blogitemtitle">
		Almost a week in Kuala Lumpur
		</h4>





			<div className="blogitembody">
			Somebody probably suspects me to be a terrorist - today I left two water bottles unattended at monorail ticket centres.  Both were set down on the counters while I paid for my tickets, and forgotten when I left for the train platforms!<br /><br />Yesterday I awoke sick-in-the-bowels, and I couldn't stray too far from my hostel.  I've tried to avoid drinking tap water here, perhaps it was the laksa I ate the night before on "hawker street" in the Golden Triangle?  I'll let it go as a mystery, and I think I am feeling a bit better today.  "Hawker street" reeks of garbage, sewage, and clove cigarettes, and I have seen many speedy rats racing to and from the storm sewers.<br /><br />Speaking of storm sewers, it is cool to watch water gush out of them and fill the street when it rains.  Lately, when it rains, it pours!  Every day I have ran to find cover from monsoon rain - and it has been humid everyday.  My little umbrella, from Chinatown in Singapore, cannot withstand a monsoon downpour.<br /><br />New Year's Eve was interesting - and fortunately dry.  People filled the streets in the Golden Triangle to hear bands and DJ's.  I also saw quite a party at the night clubs lining a street that leads to the Petronas Towers, which are a wonderful display of light at night.  As the clock struck 2006, fireworks went off in at least two seperate sections of the city.<br /><br />It feels great to have a new plan:  tomorrow I fly to Phuket, Thailand.  I am hoping to escape the monson rains and find some sun, beach, and hopefully less humidity so I can play my guitar more.  There are some places near Phuket that I may go see, as well, such as Krabi and area.  I am excited!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:34 PM &nbsp;
			</div>








		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
